export default {
  appConfigurationLoaded: store => !!store.appConfiguration,
  appVersion: store => store.packageVersion,
  autoRefreshInterval: store => (store.appConfiguration
    ? store.appConfiguration.autoRefreshInterval : 120),
  blockUserByAccessAttempts: store => store.appConfiguration
    && store.appConfiguration.blockUserByAccessAttempts,
  currentFontSize: store => store.currentFontSize,
  currentFontSizeIndex: store => store.manageFontSizesClasses
    .findIndex(fontClass => store.currentFontSize === fontClass),
  errorGettingApplicationData: store => !!store.errorGettingApplicationData,
  getLanguage: store => langKey => store.languages.find(language => language.key === langKey),
  isOffLineMode: store => store.appConfiguration && store.appConfiguration.offLineMode,
  language: store => store.language,
  languages: store => store.languages,
  limitOfPhysicalChemicalParametersCustomizations: store => (store.appConfiguration
    ? store.appConfiguration.limitOfPhysicalChemicalParametersCustomizations : 3),
  manageFontSizesClasses: store => store.manageFontSizesClasses,
  maxAccessAttempts: store => (store.appConfiguration
    && store.appConfiguration.allowedAccessAttempts) || 0,
  mySigmaVariablesLimit: store => store.appConfiguration
    && store.appConfiguration.mySigmaVariablesLimit,
  nextFontSize: (store, getters) => store.manageFontSizesClasses[getters.currentFontSizeIndex + 1],
  previousFontSize: (store, getters) => store
    .manageFontSizesClasses[getters.currentFontSizeIndex - 1],
  theme: store => store.appTheme,
  isPrinting: store => store.isPrinting,
  apiUnreachable: store => store.apiUnreachable,
  hotjarInjectionClass: store => store.appConfiguration.hotjarInjectionClass,
  limitVariablesHistoryData: store => store.appConfiguration.limitVariablesHistoryData,
  limitHistoricalPeriodDataInDays: store => store.appConfiguration.limitHistoricalPeriodDataInDays,
};
